import { Box } from '@chakra-ui/react';
import { ReactNode } from 'react';

export const CardWithShadow = ({ children, ...restProps }: { children: ReactNode; [key: string]: any }) => {
  return (
    <Box boxShadow='var(--chakra-colors-brand-blueShadow)' borderRadius={10} background='brand.white' {...restProps}>
      {children}
    </Box>
  );
};
